import type React from 'react';

type StatusIconProps = {
  size?: number;
  className?: string;
};

type CircleStatusIconProps = StatusIconProps & {
  backgroundColor: string;
  glyphColor?: string;
};

export const CheckGlyph: React.FC<StatusIconProps> = ({ size = 24, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden={true}
  >
    <path
      d="M5 12.5L9.5 17L19 7"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XCloseGlyph: React.FC<StatusIconProps> = ({ size = 24, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden={true}
  >
    <path d="M7 7L17 17M17 7L7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const CircleCheckIcon: React.FC<CircleStatusIconProps> = ({
  size = 40,
  backgroundColor,
  glyphColor = 'currentColor',
  className,
}) => (
  <span
    className={className}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      borderRadius: '50%',
      backgroundColor,
      color: glyphColor,
      flexShrink: 0,
    }}
    aria-hidden={true}
  >
    <CheckGlyph size={Math.round(size * 0.55)} />
  </span>
);

export const CircleXCloseIcon: React.FC<CircleStatusIconProps> = ({
  size = 20,
  backgroundColor,
  glyphColor = 'currentColor',
  className,
}) => (
  <span
    className={className}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      borderRadius: '50%',
      backgroundColor,
      color: glyphColor,
      flexShrink: 0,
    }}
    aria-hidden={true}
  >
    <XCloseGlyph size={Math.round(size * 0.7)} />
  </span>
);

export const ChevronRightSmall: React.FC<StatusIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden={true}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 5L15 12L7 19L8 20C10.13 18.31 15.2789 13.589 17 12C15.7222 10.838 16.9689 11.98 8 4L7 5Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronLeftSmall: React.FC<StatusIconProps> = ({ size = 16, className }) => (
  <span style={{ display: 'inline-flex', transform: 'rotate(180deg)' }} aria-hidden={true}>
    <ChevronRightSmall size={size} className={className} />
  </span>
);
